import { FC, useEffect } from 'react';

import classnames from 'classnames';

import { If } from '@hsp/react-component-library';

import { Pages, PageSizes, Total } from 'components/table/components/paginator/components';
import { useTableStoreSelector, useTableStoreSet } from 'components/table/hooks';
import { IPaginatorProps } from 'types/components/table/components';

import './paginator.component.scss';

const Paginator: FC<IPaginatorProps> = ({
  disabled = false,
  maxPageButtons = 5,
  page = 1,
  pageSizeOptions = [10, 25, 50, 100],
  showFirstLastButtons = true,
  totalType = 'recordCount',
}) => {
  const total = useTableStoreSelector((state) => state.total);
  const setStore = useTableStoreSet();

  useEffect(() => setStore({ page }), [page, setStore]);

  return (
    <If condition={total > 0}>
      <div className={classnames('paginator-wrapper', { disabled: disabled })}>
        <PageSizes
          onPageSizeChanged={(newPageSize) => setStore({ pageSize: newPageSize })}
          pageSizeOptions={pageSizeOptions}
        />
        <Total totalType={totalType} />
        <Pages
          maxPageButtons={maxPageButtons}
          onPageChanged={(newPage) => setStore({ page: newPage })}
          showFirstLastButtons={showFirstLastButtons}
        />
      </div>
    </If>
  );
};

export default Paginator;
